import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <>
      <header className="page-header">
        <h1 className="page-title">Page Not Found</h1>
      </header>
      
      <div className="page-placeholder">
        <p className="page-placeholder__text">
          The page you're looking for doesn't exist.
        </p>
        <p style={{ marginTop: '16px' }}>
          <Link to="/qr-codes">Go to QR Codes</Link>
        </p>
      </div>
    </>
  );
};

export default NotFound;
